<template>
    <div class="two-fa-verify-code-sec">
        <input
            v-for="(digit, index) in digits"
            :key="index"
            :ref="el => { if (el) inputRefs[index] = el }"
            type="text"
            class="form-control"
            :value="digit"
            maxlength="1"
            inputmode="numeric"
            autocomplete="off"
            :disabled="disabled"
            @input="onInput($event, index)"
            @keydown="onKeydown($event, index)"
            @paste="onPaste($event)"
            @focus="onFocus($event)"
        />
    </div>
</template>

<script>
export default {
    name: 'OtpInput',
    props: {
        modelValue: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        length: {
            type: Number,
            default: 6
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            digits: Array(this.length).fill(''),
            inputRefs: []
        };
    },
    watch: {
        modelValue(val) {
            if (val === '') this.clear();
        }
    },
    mounted() {
        this.$nextTick(() => this.inputRefs[0]?.focus());
    },
    methods: {
        onFocus(event) {
            event.target.select();
        },
        onInput(event, index) {
            const val = event.target.value.replace(/\D/g, '');
            event.target.value = val ? val[0] : '';
            const digits = [...this.digits];
            digits[index] = val ? val[0] : '';
            this.digits = digits;
            this.emit();
            if (val && index < this.length - 1) {
                this.$nextTick(() => this.inputRefs[index + 1]?.focus());
            }
        },
        onKeydown(event, index) {
            if (event.key === 'Backspace') {
                if (this.digits[index]) {
                    const digits = [...this.digits];
                    digits[index] = '';
                    this.digits = digits;
                    this.emit();
                } else if (index > 0) {
                    const digits = [...this.digits];
                    digits[index - 1] = '';
                    this.digits = digits;
                    this.emit();
                    this.$nextTick(() => this.inputRefs[index - 1]?.focus());
                }
                event.preventDefault();
            }
            const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
            if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
                event.preventDefault();
            }
        },
        onPaste(event) {
            event.preventDefault();
            const pasted = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, this.length);
            if (!pasted) return;
            const digits = Array(this.length).fill('');
            pasted.split('').forEach((char, i) => { digits[i] = char; });
            this.digits = digits;
            this.emit();
            const lastIndex = Math.min(pasted.length - 1, this.length - 1);
            this.$nextTick(() => {
                this.inputRefs[lastIndex]?.focus();
            });
        },
        emit() {
            this.$emit('update:modelValue', this.value);
        },
        clear() {
            this.digits = Array(this.length).fill('');
            this.$nextTick(() => this.inputRefs[0]?.focus());
        }
    },
    computed: {
        value() {
            return this.digits.join('');
        }
    }
};
</script>
